import { i18nBackend } from '@mssgme/i18n';

function resolver(language) {
    return import(
        /* webpackInclude: /\.json$/ */
        `./${language}/inbox.json`
    );
}

i18nBackend.registerResolver('inbox', resolver);
